var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.29719 7.66039C5.05668 7.48001 4.70806 7.55162 4.6185 7.83861C4.54149 8.08539 4.5 8.34785 4.5 8.62V10.25C4.5 10.3881 4.61193 10.5 4.75 10.5H5.75C6.16421 10.5 6.5 10.8358 6.5 11.25C6.5 11.6642 6.16421 12 5.75 12L4.25 12C3.83579 12 3.5 12.3358 3.5 12.75C3.5 13.1636 3.83486 13.4991 4.24829 13.5H7.75C8.16421 13.5 8.5 13.8358 8.5 14.25C8.5 14.6642 8.16421 15 7.75 15H4.75C4.61193 15 4.5 15.1119 4.5 15.25V15.38C4.5 16.827 5.67301 18 7.12 18H16.88C18.327 18 19.5 16.827 19.5 15.38V8.62C19.5 8.34785 19.4585 8.08539 19.3815 7.83861C19.2919 7.55162 18.9433 7.48001 18.7028 7.66039L13.65 11.45C12.6722 12.1833 11.3278 12.1833 10.35 11.45L5.29719 7.66039Z",
    fill: "#2c8ec6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4026 6.76053C17.7 6.5375 17.6494 6.08723 17.282 6.03065C17.151 6.01047 17.0167 6 16.88 6H7.12C6.98329 6 6.84903 6.01047 6.71797 6.03065C6.35059 6.08723 6.3 6.5375 6.59737 6.76053L11.25 10.25C11.6944 10.5833 12.3056 10.5833 12.75 10.25L17.4026 6.76053Z",
    fill: "#2c8ec6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mailIcon.8b49545795884ccfb83cdb39fa236d36.svg";
export { ForwardRef as ReactComponent };